namespace Portico.Models.Enterprise {
	import pmg = Portico.Models.Gateway;
	import psge = apigateway.enums;
	import psgm = apigateway.models;

	function isEither<T,U>(obj): obj is Partial<T & U> {
		return true;
	}


	export interface IPayor {
		id: number;
		name: string;
		bin: string;
		group: string;
		isPlaceholder: boolean;
		pcn: string;
		type: psge.PayorType; // pmg.PayorType

		addresses: Address[];
		emailAddresses: EmailAddress[];
		phoneNumbers: PhoneNumber[];
		webAddresses: WebAddress[];
		coverageAreas: PayorCoverageArea[];

		addAddress(index?: number): Address;
		addEmailAddress(index?: number): EmailAddress;
		addPhoneNumber(index?: number): PhoneNumber;
		addWebAddress(index?: number): WebAddress;
		isValidSearch(): boolean;
	}

	// function enumValue<T>(type: T) : PropertyDecorator{
	// 	return (target: Object, propertyKey: string) => {
	// 		const key = `_${propertyKey}`;
	// 		Object.defineProperty(target, propertyKey, {
	// 			enumerable: true,
	// 			configurable: false,
	// 			get() {
	// 				return this[key];
	// 			},
	// 			set(value: any) {
	// 				if (typeof value === 'number') {
	// 					this[key] = value;
	// 					return
	// 				}
	// 				this[key] = type[value];
	// 			}
	// 		});
	// 	};
	// }

	export class Payor implements IPayor {
		id: number;
		name: string;
		bin: string;
		group: string;
		isPlaceholder: boolean;
		pcn: string;
		// @enumValue(pmg.RoleType)
		// type: keyof typeof pmg.RoleType | pmg.RoleType;
		type: psge.PayorType; // pmg.PayorType
		addresses: Address[];
		emailAddresses: EmailAddress[];
		phoneNumbers: PhoneNumber[];
		webAddresses: WebAddress[];
		coverageAreas: PayorCoverageArea[];

		constructor(obj?: Partial<IPayor> | psgm.PayorModel) {
			this.id = null;
			this.name = '';
			this.bin = '';
			this.group = '';
			this.isPlaceholder = false;
			this.pcn = '';
			this.type = null;
			this.addresses = [];
			this.emailAddresses = [];
			this.phoneNumbers = [];
			this.webAddresses = [];
			this.coverageAreas = [];

			if (isEither<IPayor, psgm.PayorModel>(obj)) {
				this.id = obj.id || obj.payorId || null;
				this.name = obj.name || obj.payorName || '';
				this.bin = obj.bin || obj.payorBin || '';
				this.group = obj.group || obj.payorGroup || '';
				this.isPlaceholder = obj.isPlaceholder || false;
				this.pcn = obj.pcn || obj.payorPcn || '';
				this.type = obj.type || <psge.PayorType>obj.payorType || psge.PayorType.INS; // pmg.PayorType.PAYER;

				if (obj.addresses) {
					for (const address of obj.addresses) {
						this.addresses.push(new Address(address));
					}
				}

				if (obj.emailAddresses) {
					for (const emailAddress of obj.emailAddresses) {
						this.emailAddresses.push(new EmailAddress(emailAddress));
					}
				}

				if (obj.phoneNumbers) {
					for (const phoneNumber of obj.phoneNumbers) {
						this.phoneNumbers.push(new PhoneNumber(phoneNumber));
					}
				}

				if (obj.webAddresses) {
					for (const webAddress of obj.webAddresses) {
						this.webAddresses.push(new WebAddress(webAddress));
					}
				}

				if (obj.coverageAreas) {
					for (const coverageArea of obj.coverageAreas) {
						this.coverageAreas.push(new PayorCoverageArea(coverageArea));
					}
				}
			}
		}

		addAddress(index: number = null): Address {
			const length = this.addresses.length;

			if (index && index < length) {
				return this.addresses[index];
			}

			const address = new Address();
			this.addresses.push(address);
			return address;
		}

		addEmailAddress(index: number = null): EmailAddress {
			const length = this.emailAddresses.length;

			if (index && index < length) {
				return this.emailAddresses[index];
			}

			const emailAddress = new EmailAddress();
			this.emailAddresses.push(emailAddress);
			return emailAddress;
		}

		addPhoneNumber(index: number = null): PhoneNumber {
			const length = this.phoneNumbers.length;

			if (index && index < length) {
				return this.phoneNumbers[index];
			}

			const phoneNumber = new PhoneNumber();
			this.phoneNumbers.push(phoneNumber);
			return phoneNumber;
		}

		addWebAddress(index: number = null): WebAddress {
			const length = this.webAddresses.length;

			if (index && index < length) {
				return this.webAddresses[index];
			}

			const webAddress = new WebAddress();
			this.webAddresses.push(webAddress);
			return webAddress;
		}

		isValidSearch(): boolean {
			let counter = 0;

			if (this.name) {
				counter++;
			}

			if (this.addresses) {
				if (this.addresses[0].city) {
					counter++;
				}

				if (this.addresses[0].state) {
					counter++;
				}

				if (this.addresses[0].zip) {
					counter++;
				}
			}

			return counter >= 1;
		}
	}

    export interface IPayorBenefit {
		//accountId: number;
		//payorId: number;
		//name: string;
		//isPrimary: boolean;
		//coverageOrder: number;
		//createDate: Date;
		policyHolderFirstName: string;
		policyHolderLastName: string;
		dateOfBirth: Date;
		relationshipToPatient: string;
		phone: string;
		personCode: string;
		policyNumber: string;
		policyName: string;
		groupNumber: string;
		bin: string;
		pcn: string;
		planType: number;
		planEffectiveDate: Date;
		planExpirationDate: Date;
		planTerminationDate: Date;
	}

	export class PayorBenefit implements IPayorBenefit {
		// accountId: number;
		// payorId: number;
		// name: string;
		// isPrimary: boolean;
		// coverageOrder: number;
		// createDate: Date;
		policyHolderFirstName: string;
		policyHolderLastName: string;
		dateOfBirth: Date;
		relationshipToPatient: string;
		phone: string;
		personCode: string;
		policyNumber: string;
		policyName: string;
		groupNumber: string;
		bin: string;
		pcn: string;
		planType: number; // string;
		planEffectiveDate: Date;
		planExpirationDate: Date;
		planTerminationDate: Date;

		constructor(obj?: IPayorBenefit | any) {
			// this.accountId = null;
			// this.payorId = null;
			// this.name = '';
			// this.isPrimary = false;
			// this.coverageOrder = 0;
			// this.createDate = null;
			this.policyHolderFirstName = '';
			this.policyHolderLastName = '';
			this.dateOfBirth = null;
			this.relationshipToPatient = '';
			this.phone = '';
			this.personCode = '';
			this.policyNumber = '';
			this.policyName = '';
			this.groupNumber = '';
			this.bin = '';
			this.pcn = '';
			this.planType = null;
			this.planEffectiveDate = null;
			this.planExpirationDate = null;
			this.planTerminationDate = null;

			if (obj) {
				// this.accountId = obj.accountId || null;
				// this.payorId = obj.payorId || null;
				// this.name = obj.name || '';
				// this.isPrimary = obj.isPrimary || false;
				// this.coverageOrder = obj.coverageOrder || 0;

				//if (obj.createDate) {
				//	this.createDate = new Date(obj.createDate.toString());
				//}

				this.policyHolderFirstName = obj.policyHolderFirstName || '';
				this.policyHolderLastName = obj.policyHolderLastName || '';

				if (obj.dateOfBirth) {
					this.dateOfBirth = new Date(obj.dateOfBirth.toString());
				}

				this.relationshipToPatient = (obj.relationshipToPatient || '').toString();
				this.phone = obj.phone || '';
				this.personCode = obj.personCode || '';
				this.policyNumber = obj.policyNumber || '';
				this.policyName = obj.policyName || obj.name || '';
				this.groupNumber = obj.groupNumber || '';
				this.bin = obj.bin || '';
				this.pcn = obj.pcn || '';
				this.planType = obj.planType || null;

				if (obj.planEffectiveDate) {
					this.planEffectiveDate = new Date(obj.planEffectiveDate.toString());
				}

				if (obj.planExpirationDate) {
					this.planExpirationDate = new Date(obj.planExpirationDate.toString());
				}

				if (obj.planTerminationDate) {
					this.planTerminationDate = new Date(obj.planTerminationDate.toString());
				}
			}
		}
    }
}
